import { FC, useEffect } from "react";
import { usePopupStore, useThemeStore } from "../stores";
import { Column } from "../components/containers";
import { JustifyContent } from "../components/containers/types";

const Popup: FC = () => {
  const { popupBody, setPopupBody, popupProperties } = usePopupStore();
  const theme = useThemeStore((state) => state.theme);

  const onContainerClick: React.MouseEventHandler<HTMLDivElement> = (
    e
  ): void => {
    if (e.target === e.currentTarget) {
      setPopupBody(null);
    }
  };

  useEffect(() => {
    if (popupBody === null) {
      document.body.style.overflow = "hidden";
    }
    document.body.style.overflow = "scroll";
  }, [popupBody]);

  if (popupBody === null) return <></>;
  return (
    <Column
      justifyContent={JustifyContent.Center}
      style={styles.container}
      props={{ onClick: onContainerClick }}
    >
      <div
        style={{
          background: theme.overlay,
          ...styles.body,
          ...popupProperties.style,
        }}
        {...popupProperties.props}
        className={popupProperties.className}
      >
        {popupBody}
      </div>
    </Column>
  );
};

export default Popup;

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    backdropFilter: "blur(25px)",
    background: "rgba(0, 0, 0, 0.6)",
  },
  body: {
    width: "100%",
    maxWidth: 1000,
    minHeight: 100,
    borderRadius: 15,
  },
};
